// extracted by mini-css-extract-plugin
export var backupIcon = "_nq-1";
export var image = "_nq-0";